import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { 
  LayoutDashboard, 
  ShoppingBag, 
  ShoppingCart, 
  Users, 
  Settings, 
  LogOut,
  ChevronLeft,
  Globe,
  Info,
  Mail,
  ShieldCheck,
  FileCheck,
  Layers,
  Grid,
  Image,
  Ticket,
  HelpCircle
} from 'lucide-react';
import './Sidebar.css';
  import Cookies from 'js-cookie';

const Sidebar = () => {

const navigate = useNavigate();

const handleLogout = () => {
  Cookies.remove('auth_token');
  localStorage.clear();
  sessionStorage.clear();
  navigate('/', { replace: true });
};
  const menuItems = [
    { name: 'Dashboard', icon: <LayoutDashboard size={20} />, path: '/dashboard' },
    { name: 'Products', icon: <ShoppingBag size={20} />, path: '/products' },
    { name: 'Orders', icon: <ShoppingCart size={20} />, path: '/orders' },
    // { name: 'Customers', icon: <Users size={20} />, path: '/customers' },
    { name: 'Categories', icon: <Layers size={20} />, path: '/categories' },
    { name: 'Sub Categories', icon: <Grid size={20} />, path: '/sub-categories' },
    { name: 'Banners', icon: <Image size={20} />, path: '/banners' },
    { name: 'Coupons', icon: <Ticket size={20} />, path: '/coupons' },
    { name: 'FAQs', icon: <HelpCircle size={20} />, path: '/faqs' },
  ];

  const contentItems = [
    { name: 'About Us', icon: <Info size={20} />, path: '/about-us' },
    { name: 'Contact Us', icon: <Mail size={20} />, path: '/contact-us' },
    { name: 'Privacy Policy', icon: <ShieldCheck size={20} />, path: '/privacy-policy' },
    { name: 'Terms & Conditions', icon: <FileCheck size={20} />, path: '/terms-conditions' },
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="logo-icon">R</div>
        <h2 className="brand-name">OYAL FURNISHERS</h2>
      </div>

      <nav className="sidebar-nav">
        {/* <div className="nav-group-label">MAIN MENU</div> */}
        {menuItems.map((item) => (
          <NavLink 
            key={item.name} 
            to={item.path} 
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-text">{item.name}</span>
          </NavLink>
        ))}

        {/* <div className="nav-group-label">CONTENT MANAGEMENT</div>
        {contentItems.map((item) => (
          <NavLink 
            key={item.name} 
            to={item.path} 
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-text">{item.name}</span>
          </NavLink>
        ))} */}
      </nav>

      <div className="sidebar-footer">
        <button onClick={handleLogout} className="logout-btn">
          <LogOut size={20} />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
